import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobeEurope } from 'react-icons/fa';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center space-x-1">
      <div className="text-accent mr-0.5">
        <FaGlobeEurope size={14} />
      </div>
      <button 
        onClick={() => changeLanguage('en')} 
        className={`px-2 py-1 text-xs font-medium rounded-full transition-all ${
          i18n.language === 'en' 
            ? 'bg-dark-accent/50 text-accent ring-1 ring-accent/30' 
            : 'text-light/70 hover:text-light hover:bg-dark-accent/20'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <button 
        onClick={() => changeLanguage('tr')} 
        className={`px-2 py-1 text-xs font-medium rounded-full transition-all ${
          i18n.language === 'tr' 
            ? 'bg-dark-accent/50 text-accent ring-1 ring-accent/30' 
            : 'text-light/70 hover:text-light hover:bg-dark-accent/20'
        }`}
        aria-label="Switch to Turkish"
      >
        TR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
